<style>
.day-money{
    height: 100%;
}
</style>

<template>
    <div class="day-money">
        <v-chart :option="option" :init-options="initOptions" ref="day-money" autoresize />
    </div>
</template>

<script>
import { isOpen } from '@/utils/index'
import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 

export default {
    name: 'MothMoney',
    data() {
        return {
            initOptions: {
                renderer: 'canvas'
            },
            option: {
                series:[],//不知道为什么脱离了这个编辑器，没有这个会报错
                //backgroundColor:'#5B5C6E',
                sum:11111,
                sumtime:200,
                graphic:[
                    {
                    id:"logo",
                    type: 'group',
                    left: '10px',
                    top: '10%',
                    children:[
                        {
                            type: 'text',
                            z: 100,
                            left: 'left',
                            top: '30px',
                            style: {
                                fill: '#fff',
                                // text: 0,
                                font: '50px Microsoft YaHei',
                                text: '0.00'
                            }
                        },
                        {
                            type: 'text',
                            z: 100,
                            left: 'left',
                            top: 'middle',
                            style: {
                                fill: '#fff',
                                text: '今日GSV / ¥',
                                font: '22px Microsoft YaHei'
                            }
                        },
                    
                        {
                            type: 'text',
                            z: 100,
                            left: 'left',
                            top: 90,
                            style: {
                                
                                text:'整体环比:',
                                fill:'#FFF',
                                font: '14px Microsoft YaHei'
                            }
                        }
                        ,
                        {
                            type: 'image',
                            z: 100,
                            top: 72,
                            left:60,
                            style: {
                                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABTUlEQVRoQ+2TMU7DQBBFZyTcBBdu9hwxEluDj8ANuAFX4QbJEbhBTJ0g+QbQW0gubAosmCiISMhgkPm7gkjftf943vtjlQN/9MD3FwL8dYNsgA2ABnhCoEA4zgZgheAANgAKhONsAFYIDmAD3wnsnF+aSJnW6yUoejQerYHW+WtVuXr78svrxfHj3U0MiCgArfOXqrLYL2xmjYgWab2uQkMEBxguHxsiKEDrfC5iK1XNvjIdo4lgAD8t/wHoYfbcn2hTNSHOKQiAZXnWJUf3Y+Y/LWpSzfq+CAEBA+yWf0qSlajkk4wGgoABOucrUZlPWv79ZTMr03pT/Ca7z8AAw4+37rRU1bORn/g2rTfnyMLDLAHYAHhPPCGe0H87IXCfyfHg/8DkDcAAAUCBcJwNwArBAWwAFAjH2QCsEBzABkCBcJwNwArBAWwAFAjHtzMqhjGeG73tAAAAAElFTkSuQmCC',
                                
                            }
                        },
                        {
                            type: 'text',
                            z: 100,
                            // left: 'left',
                            top: 90,
                            left:95,
                            style: {
                                
                                text: '21.04%',
                                fill:'#FFF',
                                font: '14px Microsoft YaHei'
                            }
                        }
                        ,
                        {
                            type: 'text',
                            z: 100,
                            left: 'left',
                            top: 110,
                            style: {
                                
                                text:'整体同比:',
                                fill:'#FFF',
                                font: '14px Microsoft YaHei'
                            }
                        }
                        ,
                        {
                            type: 'image',
                            z: 100,
                            top: 93,
                            left:60,
                            style: {
                                image: 'data:image/png;base64,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',
                                
                            }
                        },
                        {
                            type: 'text',
                            z: 100,
                            // left: 'left',
                            top: 110,
                            left:95,
                            style: {
                                
                                text:'51.32%',
                                fill:'#FFF',
                                font: '14px Microsoft YaHei'
                            }
                        }
                        
                    ]
                }]
            }
        }
    },
    mounted() {
        // this.$moment
        let flag = true
        // if(isOpen()){
        let opentime = moment({hour: 11, minute: 15});

        let that = this
        setInterval(()=>{
            if(isOpen()&&flag){
                let nowdate = moment();
                // let endtime = this.$moment({hour: 21, minute: 30});
                let seconds = this._.ceil(this._.divide(moment.duration(nowdate.diff(opentime)).asSeconds(), 3),0);
                let sum = this._.multiply(60,seconds)
                // console.log(sum)
                this.option.graphic[0].children[0].style.text = sum
                flag = false
            }else if(isOpen()){
                that.option.graphic[0].children[0].style.text += that._.random(105,121.5)
            }
        },3500)
        // }
    },
}
</script>
